<div class="py-4 container-fluid disb-memo-page">
  <h4 class="mb-4 disb-memo-title">การจัดการบันทึกข้อความเบิกจ่ายค่าตอบแทนการสอน</h4>

  <div class="segmented-tabs disb-memo-tabs" role="tablist" aria-label="เลือกหลักสูตรสำหรับการจัดทำใบปะหน้า">
    <button
      type="button"
      id="disbMemoTabRegular"
      class="segmented-tab"
      role="tab"
      aria-controls="disbMemoPanelRegular"
      [attr.aria-selected]="activeTab() === 'regular'"
      [class.active]="activeTab() === 'regular'"
      (click)="onTabChange('regular')"
    >
      หลักสูตรปกติ
    </button>
    <button
      type="button"
      id="disbMemoTabInternational"
      class="segmented-tab"
      role="tab"
      aria-controls="disbMemoPanelInternational"
      [attr.aria-selected]="activeTab() === 'international'"
      [class.active]="activeTab() === 'international'"
      (click)="onTabChange('international')"
    >
      หลักสูตรนานาชาติ
    </button>
  </div>

  <div class="disb-memo-card">
    <div class="disb-memo-card-body">
      <div class="disb-memo-toolbar" [formGroup]="filterForm">
        <div class="disb-memo-filter">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermNameOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-memo-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="academicYear"
            [options]="academicYearOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-memo-filter">
          <app-select
            label="สาขาวิชา"
            formControlName="departmentId"
            [options]="departmentOptions()"
            bindLabel="name"
            bindValue="id"
            placeholder="ทั้งหมด"
            [clearable]="true"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>
      </div>

      @if (activeTab() === 'regular') {
        <div
          id="disbMemoPanelRegular"
          class="disb-memo-tab-panel"
          role="tabpanel"
          aria-labelledby="disbMemoTabRegular"
        >
          @if (canIssueCoverMemo) {
            <p class="disb-memo-caption">
              จัดทำใบปะหน้า (บันทึกข้อความเบิกจ่ายค่าตอบแทนการสอน) แยกตามรอบและสาขาวิชา
              โดยสามารถเลือกรายชื่ออาจารย์ที่ต้องการจัดทำใบปะหน้าได้
            </p>
          } @else {
            <p class="disb-memo-caption">{{ readOnlyCaption }}</p>
          }

          @if (regularLoading()) {
            <p class="disb-memo-loading">กำลังโหลดข้อมูล...</p>
          } @else if (regularGroups().length === 0) {
            <p class="disb-memo-empty">ไม่พบสาขาวิชาที่มีสิทธิ์จัดทำใบปะหน้าในเทอมนี้</p>
          } @else {
            @for (group of regularGroups(); track group.department.id) {
              <div class="disb-memo-group-card">
                <div class="disb-memo-group-header">
                  <div class="disb-memo-group-header-info">
                    <div class="disb-memo-group-title">{{ departmentName(group.department) }}</div>
                    <button
                      type="button"
                      class="disb-memo-pending-chip disb-memo-pool-toggle"
                      [disabled]="regularPendingEntries(group).length === 0"
                      [attr.aria-expanded]="isPoolExpanded(poolKey('regular', group))"
                      [attr.aria-controls]="poolListId('regular', group)"
                      [title]="poolToggleTitle(poolKey('regular', group), regularPendingEntries(group).length)"
                      (click)="onTogglePool(poolKey('regular', group))"
                    >
                      <span>รอดำเนินการ {{ group.pending_count }} รายการ</span>
                      <svg
                        class="disb-memo-pool-toggle-caret"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </button>
                  </div>
                  @if (canIssueCoverMemo) {
                    <div class="disb-memo-group-header-actions">
                      <span class="disb-memo-btn-wrap" [title]="issueButtonTitle(group)">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          [disabled]="!canIssueRound(group)"
                          (click)="onOpenIssueDialog(group, 'regular')"
                        >
                          จัดทำใบปะหน้า
                        </button>
                      </span>
                    </div>
                  }
                </div>

                @if (group.window_closed) {
                  <p class="disb-memo-window-closed-banner">
                    หมดเขตการส่งเบิกของสาขานี้แล้ว — ไม่สามารถจัดทำใบปะหน้าใหม่หรือแก้ไขรอบเดิมได้
                  </p>
                }

                @if (regularPendingEntries(group).length > 0 && isPoolExpanded(poolKey('regular', group))) {
                  <ul class="disb-memo-pool-list disb-memo-pool-list-standalone" [id]="poolListId('regular', group)">
                    @for (entry of regularPendingEntries(group); track entry.id) {
                      <li class="disb-memo-pool-row">
                        <span class="disb-memo-pool-label">{{ entry.label }}</span>
                        <span class="disb-memo-pool-amount">{{ formatAmount(entry.amount) }}</span>
                      </li>
                    }
                  </ul>
                }

                @if (group.rounds.length > 0) {
                  <ul class="disb-memo-round-list">
                    @for (round of group.rounds; track round.id) {
                      <li class="disb-memo-round-card">
                        <div class="disb-memo-round-card-head">
                          <div class="disb-memo-round-card-title">
                            <h6>เลขที่ {{ round.document_number || '-' }}</h6>
                            <app-status-badge
                              [tone]="roundStatusDisplay(round).tone"
                              [label]="roundStatusDisplay(round).label"
                            />
                            @if (canIssueCoverMemo && canDeleteRound(round)) {
                              <button
                                type="button"
                                class="disb-memo-action-button disb-memo-action-button-danger ms-auto"
                                title="ลบใบปะหน้า"
                                aria-label="ลบใบปะหน้า"
                                (click)="onOpenDeleteConfirm(round)"
                              >
                                <svg
                                  class="disb-memo-action-icon"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="1.8"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  aria-hidden="true"
                                >
                                  <path d="M4 7h16" />
                                  <path d="M10 4h4a1 1 0 0 1 1 1v2H9V5a1 1 0 0 1 1-1Z" />
                                  <path d="M6 7v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7" />
                                  <path d="M10 11v6" />
                                  <path d="M14 11v6" />
                                </svg>
                              </button>
                            }
                          </div>
                          <div class="disb-memo-round-card-meta">
                            <span>{{ round.round_no !== null ? 'รอบที่ ' + round.round_no : '-' }}</span>
                            <span>ลงวันที่ {{ formatDate(round.issued_on) }}</span>
                            <span>{{ teacherCell(round) }}</span>
                            <span>ยอดรวม {{ formatAmount(round.total_amount) }} บาท</span>
                          </div>
                        </div>

                        @switch (roundCardState(round)) {
                          @case ('draft') {
                            <p class="disb-memo-round-note">รอส่งตรวจสอบและรับรอง</p>
                          }
                          @case ('returned') {
                            <div class="disb-memo-round-returned">
                              <strong>เหตุผล</strong>
                              <p class="disb-memo-round-returned-comment">{{ round.send_back_comment || '-' }}</p>
                              @if (round.send_back_by?.full_name) {
                                <span class="disb-memo-round-returned-by">
                                  โดย {{ round.send_back_by?.full_name }} เมื่อ {{ formatDate(round.returned_at) }}
                                </span>
                              }
                            </div>
                          }
                          @case ('pending') {
                            <div class="disb-memo-round-stepper" aria-label="ขั้นตอนการรับรองรอบส่งเบิก">
                              <ol class="disb-memo-round-stepper-list">
                                @for (step of roundSteps(round); track step.key) {
                                  <li class="disb-memo-round-stepper-item" [ngClass]="'disb-memo-round-stepper-' + step.state">
                                    <span class="disb-memo-round-stepper-role">{{ step.label }}</span>
                                    @if (step.state === 'done' && step.actedAt) {
                                      <span class="disb-memo-round-stepper-date">ดำเนินการเมื่อ {{ formatDate(step.actedAt) }}</span>
                                    }
                                    @if (step.state === 'current') {
                                      <span class="disb-memo-round-stepper-current-badge">รอดำเนินการ</span>
                                    }
                                  </li>
                                }
                              </ol>
                            </div>
                          }
                          @case ('completed') {
                            <p class="disb-memo-round-note disb-memo-round-note-completed">
                              {{ completedNoteLabel(round) }} — {{ formatDate(round.completed_at) }}
                            </p>
                          }
                          @case ('cancelled') {
                            <p class="disb-memo-round-note">ยกเลิกเนื่องจากการแก้ไขตารางสอน</p>
                          }
                        }

                        <div class="disb-memo-round-doc">
                          <button
                            type="button"
                            class="disb-memo-round-doc-header"
                            [disabled]="!round.round_merged_fresh"
                            (click)="onToggleMergedPreview(round)"
                          >
                            <span>เอกสารส่งเบิกฉบับรวม</span>
                            <span class="disb-memo-round-doc-toggle">
                              @if (!round.round_merged_fresh) {
                                กำลังจัดทำเอกสาร...
                              } @else {
                                {{ isMergedPreviewExpanded(round.id) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}
                              }
                            </span>
                          </button>
                          @if (isMergedPreviewExpanded(round.id)) {
                            <div class="disb-memo-round-doc-preview">
                              @if (isMergedPreviewLoading(round.id)) {
                                <p class="disb-memo-round-doc-preview-loading">กำลังโหลดเอกสารรวมของรอบ...</p>
                              } @else if (mergedPreviewHasError(round.id)) {
                                <p class="disb-memo-round-doc-preview-error">{{ mergedPreviewErrorMessage(round.id) }}</p>
                              } @else {
                                @if (mergedPreviewUrl(round.id); as url) {
                                  <iframe
                                    class="disb-memo-round-doc-preview-frame"
                                    [src]="url"
                                    title="เอกสารส่งเบิกฉบับรวม"
                                  ></iframe>
                                }
                              }
                            </div>
                          }
                        </div>

                        <div class="disb-memo-round-actions">
                          @if (canIssueCoverMemo && round.editable) {
                            <span class="disb-memo-btn-wrap" [title]="editButtonTitle(round, group)">
                              <button
                                type="button"
                                class="btn btn-secondary btn-sm"
                                [disabled]="!canEditRound(round, group)"
                                (click)="onOpenEditDialog(group, round, 'regular')"
                              >
                                แก้ไข
                              </button>
                            </span>
                            <span class="disb-memo-btn-wrap" [title]="submitButtonTitle(round, group)">
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                [disabled]="!canSubmitRound(round, group) || actionLoading()"
                                (click)="onOpenSubmitConfirm(round, group)"
                              >
                                {{ submitButtonLabel(round) }}
                              </button>
                            </span>
                          }
                        </div>
                      </li>
                    }
                  </ul>
                } @else {
                  <p class="disb-memo-round-empty">ยังไม่มีรอบที่จัดทำใบปะหน้าในสาขานี้</p>
                }
              </div>
            }
          }
        </div>
      }

      @if (activeTab() === 'international') {
        <div
          id="disbMemoPanelInternational"
          class="disb-memo-tab-panel"
          role="tabpanel"
          aria-labelledby="disbMemoTabInternational"
        >
          @if (canIssueCoverMemo) {
            <p class="disb-memo-intl-caption">
              หลักสูตรนานาชาติแบ่งการจัดทำใบปะหน้าเป็น 2 ประเภท — เบิกรายวิชา
              สามารถเลือกจัดทำใบปะหน้าได้มากกว่า 1 รายวิชา โดยไม่สามารถแก้ไขรายชื่ออาจารย์ได้
              ส่วนเบิกรายอาจารย์ แยกตามรอบและสาขาวิชา โดยสามารถเลือกรายชื่ออาจารย์ที่ต้องการจัดทำใบปะหน้าได้
            </p>
          } @else {
            <p class="disb-memo-intl-caption">{{ readOnlyCaption }}</p>
          }

          @if (intlLoading()) {
            <p class="disb-memo-loading">กำลังโหลดข้อมูล...</p>
          } @else if (intlGroups().length === 0) {
            <p class="disb-memo-empty">ไม่พบข้อมูลจัดทำใบปะหน้า</p>
          } @else {
            @for (group of intlGroups(); track group.department.id) {
              <div class="disb-memo-group-card">
                <div class="disb-memo-group-header">
                  <div class="disb-memo-group-title">{{ departmentName(group.department) }}</div>
                </div>

                @if (group.window_closed) {
                  <p class="disb-memo-window-closed-banner">
                    หมดเขตการส่งเบิกของสาขานี้แล้ว — ไม่สามารถจัดทำใบปะหน้าใหม่หรือแก้ไขรอบเดิมได้
                  </p>
                }

                <div class="disb-memo-pool">
                  <div class="disb-memo-pool-head">
                    <span class="disb-memo-pool-title">เบิกจ่ายรายวิชาหลักสูตรนานาชาติ</span>
                    <button
                      type="button"
                      class="disb-memo-pool-note disb-memo-pool-toggle"
                      [disabled]="coursePendingEntries(group).length === 0"
                      [attr.aria-expanded]="isPoolExpanded(poolKey('course', group))"
                      [attr.aria-controls]="poolListId('course', group)"
                      [title]="poolToggleTitle(poolKey('course', group), coursePendingEntries(group).length)"
                      (click)="onTogglePool(poolKey('course', group))"
                    >
                      <span>รอดำเนินการ {{ coursePendingEntries(group).length }} รายการ</span>
                      <svg
                        class="disb-memo-pool-toggle-caret"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </button>
                    @if (canIssueCoverMemo) {
                      <span class="disb-memo-btn-wrap" [title]="issueButtonTitle(group)">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          [disabled]="!canIssueCourseRound(group)"
                          (click)="onOpenCourseIssueDialog(group)"
                        >
                          จัดทำใบปะหน้า
                        </button>
                      </span>
                    }
                  </div>
                  @if (coursePendingEntries(group).length > 0 && isPoolExpanded(poolKey('course', group))) {
                    <ul class="disb-memo-pool-list" [id]="poolListId('course', group)">
                      @for (entry of coursePendingEntries(group); track entry.id) {
                        <li class="disb-memo-pool-row">
                          <span class="disb-memo-pool-label">{{ entry.label }}</span>
                          <span class="disb-memo-pool-amount">{{ formatAmount(entry.amount) }}</span>
                        </li>
                      }
                    </ul>
                  }
                </div>

                <div class="disb-memo-pool">
                  <div class="disb-memo-pool-head">
                    <span class="disb-memo-pool-title">เบิกจ่ายรายอาจารย์หลักสูตรนานาชาติ</span>
                    <button
                      type="button"
                      class="disb-memo-pool-note disb-memo-pool-toggle"
                      [disabled]="batchPendingEntries(group).length === 0"
                      [attr.aria-expanded]="isPoolExpanded(poolKey('batch', group))"
                      [attr.aria-controls]="poolListId('batch', group)"
                      [title]="poolToggleTitle(poolKey('batch', group), batchPendingEntries(group).length)"
                      (click)="onTogglePool(poolKey('batch', group))"
                    >
                      <span>รอดำเนินการ {{ batchPendingEntries(group).length }} รายการ</span>
                      <svg
                        class="disb-memo-pool-toggle-caret"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </button>
                    @if (canIssueCoverMemo) {
                      <span class="disb-memo-btn-wrap" [title]="issueButtonTitle(group)">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          [disabled]="!canIssueBatchRound(group)"
                          (click)="onOpenIssueDialog(group, 'international')"
                        >
                          จัดทำใบปะหน้า
                        </button>
                      </span>
                    }
                  </div>
                  @if (batchPendingEntries(group).length > 0 && isPoolExpanded(poolKey('batch', group))) {
                    <ul class="disb-memo-pool-list" [id]="poolListId('batch', group)">
                      @for (entry of batchPendingEntries(group); track entry.id) {
                        <li class="disb-memo-pool-row">
                          <span class="disb-memo-pool-label">{{ entry.label }}</span>
                          <span class="disb-memo-pool-amount">{{ formatAmount(entry.amount) }}</span>
                        </li>
                      }
                    </ul>
                  }
                </div>

                @if (group.rounds.length > 0) {
                  <ul class="disb-memo-round-list">
                    @for (round of group.rounds; track round.id) {
                      <li class="disb-memo-round-card">
                        <div class="disb-memo-round-card-head">
                          <div class="disb-memo-round-card-title">
                            <h6>เลขที่ {{ round.document_number || '-' }}</h6>
                            <app-status-badge
                              [tone]="roundStatusDisplay(round).tone"
                              [label]="roundStatusDisplay(round).label"
                            />
                            @if (canIssueCoverMemo && canDeleteRound(round)) {
                              <button
                                type="button"
                                class="disb-memo-action-button disb-memo-action-button-danger ms-auto"
                                title="ลบใบปะหน้า"
                                aria-label="ลบใบปะหน้า"
                                (click)="onOpenDeleteConfirm(round)"
                              >
                                <svg
                                  class="disb-memo-action-icon"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="1.8"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  aria-hidden="true"
                                >
                                  <path d="M4 7h16" />
                                  <path d="M10 4h4a1 1 0 0 1 1 1v2H9V5a1 1 0 0 1 1-1Z" />
                                  <path d="M6 7v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7" />
                                  <path d="M10 11v6" />
                                  <path d="M14 11v6" />
                                </svg>
                              </button>
                            }
                          </div>
                          <div class="disb-memo-round-card-meta">
                            <span>{{ round.round_no !== null ? 'รอบที่ ' + round.round_no : '-' }}</span>
                            <span>ลงวันที่ {{ formatDate(round.issued_on) }}</span>
                            <span>{{ teacherCell(round) }}</span>
                            <span>ยอดรวม {{ formatAmount(round.total_amount) }} บาท</span>
                          </div>
                        </div>

                        @switch (roundCardState(round)) {
                          @case ('draft') {
                            <p class="disb-memo-round-note">ยังไม่ส่งตรวจสอบและรับรอง</p>
                          }
                          @case ('returned') {
                            <div class="disb-memo-round-returned">
                              <strong>เหตุผล</strong>
                              <p class="disb-memo-round-returned-comment">{{ round.send_back_comment || '-' }}</p>
                              @if (round.send_back_by?.full_name) {
                                <span class="disb-memo-round-returned-by">
                                  โดย {{ round.send_back_by?.full_name }} เมื่อ {{ formatDate(round.returned_at) }}
                                </span>
                              }
                            </div>
                          }
                          @case ('pending') {
                            <div class="disb-memo-round-stepper" aria-label="ขั้นตอนการรับรองรอบส่งเบิก">
                              <ol class="disb-memo-round-stepper-list">
                                @for (step of roundSteps(round); track step.key) {
                                  <li class="disb-memo-round-stepper-item" [ngClass]="'disb-memo-round-stepper-' + step.state">
                                    <span class="disb-memo-round-stepper-role">{{ step.label }}</span>
                                    @if (step.state === 'done' && step.actedAt) {
                                      <span class="disb-memo-round-stepper-date">ดำเนินการเมื่อ {{ formatDate(step.actedAt) }}</span>
                                    }
                                    @if (step.state === 'current') {
                                      <span class="disb-memo-round-stepper-current-badge">รอดำเนินการ</span>
                                    }
                                  </li>
                                }
                              </ol>
                            </div>
                          }
                          @case ('completed') {
                            <p class="disb-memo-round-note disb-memo-round-note-completed">
                              {{ completedNoteLabel(round) }} — {{ formatDate(round.completed_at) }}
                            </p>
                          }
                          @case ('cancelled') {
                            <p class="disb-memo-round-note">ยกเลิกเนื่องจากการแก้ไขตารางสอน</p>
                          }
                        }

                        <div class="disb-memo-round-doc">
                          <button
                            type="button"
                            class="disb-memo-round-doc-header"
                            [disabled]="!round.round_merged_fresh"
                            (click)="onToggleMergedPreview(round)"
                          >
                            <span>เอกสารส่งเบิกฉบับรวม</span>
                            <span class="disb-memo-round-doc-toggle">
                              @if (!round.round_merged_fresh) {
                                กำลังจัดทำเอกสาร...
                              } @else {
                                {{ isMergedPreviewExpanded(round.id) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}
                              }
                            </span>
                          </button>
                          @if (isMergedPreviewExpanded(round.id)) {
                            <div class="disb-memo-round-doc-preview">
                              @if (isMergedPreviewLoading(round.id)) {
                                <p class="disb-memo-round-doc-preview-loading">กำลังโหลดเอกสารรวมของรอบ...</p>
                              } @else if (mergedPreviewHasError(round.id)) {
                                <p class="disb-memo-round-doc-preview-error">{{ mergedPreviewErrorMessage(round.id) }}</p>
                              } @else {
                                @if (mergedPreviewUrl(round.id); as url) {
                                  <iframe
                                    class="disb-memo-round-doc-preview-frame"
                                    [src]="url"
                                    title="เอกสารส่งเบิกฉบับรวม"
                                  ></iframe>
                                }
                              }
                            </div>
                          }
                        </div>

                        <div class="disb-memo-round-actions">
                          @if (canIssueCoverMemo && round.editable) {
                            <span class="disb-memo-btn-wrap" [title]="editButtonTitle(round, group)">
                              <button
                                type="button"
                                class="btn btn-secondary btn-sm"
                                [disabled]="!canEditRound(round, group)"
                                (click)="onOpenEditDialog(group, round, 'international')"
                              >
                                แก้ไข
                              </button>
                            </span>
                            <span class="disb-memo-btn-wrap" [title]="submitButtonTitle(round, group)">
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                [disabled]="!canSubmitRound(round, group) || actionLoading()"
                                (click)="onOpenSubmitConfirm(round, group)"
                              >
                                {{ submitButtonLabel(round) }}
                              </button>
                            </span>
                          }
                        </div>
                      </li>
                    }
                  </ul>
                } @else {
                  <p class="disb-memo-round-empty">ยังไม่มีรอบที่จัดทำใบปะหน้าในสาขานี้</p>
                }
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</div>

@if (issueDialogOpen()) {
  <div class="disb-memo-modal-overlay" role="presentation">
    <div
      class="disb-memo-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disbMemoIssueTitle"
    >
      @if (issueTarget(); as target) {
        <div class="disb-memo-detail-header">
          <div>
            <h5 id="disbMemoIssueTitle">{{ issueDialogTitle(target) }}</h5>
            <div class="disb-memo-detail-meta">
              @for (line of issueDialogMetaLines(target); track line) {
                <span>{{ line }}</span>
              }
            </div>
          </div>
          <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseIssueDialog()"></button>
        </div>

        @if (issueStep() === 'select') {
          <div class="disb-memo-detail-body">
            <p class="disb-memo-select-caption">
              เลือกรายชื่อสำหรับจัดทำใบปะหน้า โดยจำนวนอาจารย์และยอดรวมจะคำนวณจากรายการที่เลือกเท่านั้น
              ส่วนรายการที่ไม่ได้เลือกสามารถดำเนินการในรอบถัดไปได้
            </p>

            @if (candidateEntries().length === 0) {
              <p class="disb-memo-select-empty">ไม่มีรายการที่รอดำเนินการ</p>
            } @else {
              <div class="disb-memo-select-list">
                <label class="disb-memo-select-row disb-memo-select-all">
                  <input
                    type="checkbox"
                    class="disb-memo-select-checkbox"
                    [checked]="allCandidatesSelected()"
                    [indeterminate]="someCandidatesSelected()"
                    (change)="onToggleSelectAll()"
                  />
                  <span class="disb-memo-select-label">เลือกทั้งหมด</span>
                  <span class="disb-memo-select-amount">{{ candidateEntries().length }} รายการ</span>
                </label>

                @for (entry of candidateEntries(); track entry.id) {
                  <label class="disb-memo-select-row">
                    <input
                      type="checkbox"
                      class="disb-memo-select-checkbox"
                      [checked]="isCertSelected(entry)"
                      (change)="onToggleCert(entry)"
                    />
                    <span class="disb-memo-select-label">{{ entry.label }}</span>
                    <span class="disb-memo-select-amount">{{ formatAmount(entry.amount) }}</span>
                  </label>
                }
              </div>
            }
          </div>

          <div class="disb-memo-detail-footer disb-memo-select-footer">
            <span class="disb-memo-select-summary">
              เลือกแล้ว {{ selectedCount() }} รายการ / รวม {{ formatAmount(selectedTotalAmount()) }} บาท
            </span>
            <button
              type="button"
              class="btn btn-primary"
              [disabled]="!canProceedToDetail()"
              (click)="onNextStep()"
            >
              ถัดไป
            </button>
          </div>
        } @else {
          <div class="disb-memo-detail-body">
            <form class="disb-memo-issue-form" [formGroup]="issueForm">
              <app-input
                label="เลขที่เอกสาร"
                formControlName="documentNumber"
                [required]="true"
                [error]="issueForm.controls.documentNumber.invalid && issueForm.controls.documentNumber.touched ? issueForm.controls.documentNumber.errors : null"
                classes="mb-0"
              ></app-input>

              <app-datepicker
                label="วันที่ออกเอกสาร"
                formControlName="issuedOn"
                [required]="true"
                [error]="issueForm.controls.issuedOn.invalid && issueForm.controls.issuedOn.touched ? issueForm.controls.issuedOn.errors : null"
                classes="mb-0"
              ></app-datepicker>

              <app-input
                label="เลข PR"
                formControlName="prNumber"
                classes="mb-0"
              ></app-input>

              <app-input
                label="เบอร์โทรของสาขา"
                formControlName="contactPhone"
                classes="mb-0"
              ></app-input>

              <button
                type="button"
                class="btn btn-primary btn-sm disb-memo-reload-preview"
                [disabled]="previewLoading() || issueForm.invalid"
                (click)="onGenerate()"
              >
                {{ previewLoading() ? 'กำลังสร้าง...' : 'สร้าง' }}
              </button>
            </form>

            <div class="disb-memo-preview">
              @if (previewLoading()) {
                <p class="disb-memo-preview-loading">กำลังสร้างเอกสาร...</p>
              } @else {
                @if (previewError(); as message) {
                  <p class="disb-memo-preview-error">{{ message }}</p>
                } @else {
                  @if (previewUrl(); as url) {
                    <iframe
                      class="disb-memo-preview-frame"
                      [src]="url"
                      title="ตัวอย่างใบปะหน้า"
                    ></iframe>
                  } @else {
                    <p class="disb-memo-preview-empty">กด "สร้าง" เพื่อสร้างตัวอย่างเอกสาร</p>
                  }
                }
              }
            </div>

            <div class="disb-memo-member-list">
              <h6 class="disb-memo-member-title">เอกสารทั้งหมด</h6>

              @for (entry of selectedEntries(); track entry.id) {
                <div class="disb-memo-member-row">
                  <div class="disb-memo-member-row-head">
                    <span class="disb-memo-member-label">{{ entry.label }}</span>
                    <div class="disb-memo-member-row-actions">
                      <span class="disb-memo-member-amount">{{ formatAmount(entry.amount) }}</span>
                    </div>
                  </div>

                  <div class="disb-memo-member-docs">
                    @for (row of memberDocRows(entry); track row.key) {
                      <div class="disb-memo-member-doc">
                        <div class="disb-memo-member-doc-head">
                          <span class="disb-memo-member-doc-label">{{ row.label }}</span>
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-sm"
                            (click)="onToggleMemberDocPreview(entry, row)"
                          >
                            {{ isMemberPreviewExpanded(row.key) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}
                          </button>
                        </div>

                        @if (isMemberPreviewExpanded(row.key)) {
                          <div class="disb-memo-member-preview">
                            @if (isMemberPreviewLoading(row.key)) {
                              <p class="disb-memo-member-preview-loading">กำลังโหลดเอกสาร...</p>
                            } @else if (memberPreviewHasError(row.key)) {
                              <p class="disb-memo-member-preview-error">{{ memberPreviewErrorMessage(row.key) }}</p>
                            } @else {
                              @if (memberPreviewUrl(row.key); as url) {
                                <iframe
                                  class="disb-memo-member-preview-frame"
                                  [src]="url"
                                  [title]="row.label"
                                ></iframe>
                              }
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }

              <div class="disb-memo-member-doc">
                <div class="disb-memo-member-doc-head">
                  <span class="disb-memo-member-doc-label">บันทึกข้อความ</span>
                  <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    (click)="onToggleRoundMemoPreview()"
                  >
                    {{ isMemberPreviewExpanded(roundMemoPreviewKey) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}
                  </button>
                </div>

                @if (isMemberPreviewExpanded(roundMemoPreviewKey)) {
                  <div class="disb-memo-member-preview">
                    @if (isMemberPreviewLoading(roundMemoPreviewKey)) {
                      <p class="disb-memo-member-preview-loading">กำลังโหลดเอกสาร...</p>
                    } @else if (memberPreviewHasError(roundMemoPreviewKey)) {
                      <p class="disb-memo-member-preview-error">{{ memberPreviewErrorMessage(roundMemoPreviewKey) }}</p>
                    } @else {
                      @if (memberPreviewUrl(roundMemoPreviewKey); as url) {
                        <iframe
                          class="disb-memo-member-preview-frame"
                          [src]="url"
                          title="บันทึกข้อความ"
                        ></iframe>
                      }
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="disb-memo-detail-footer">
            <button
              type="button"
              class="btn btn-secondary"
              [disabled]="issueSubmitting()"
              (click)="onBackToSelect()"
            >
              ย้อนกลับ
            </button>
            <button
              type="button"
              class="btn btn-primary"
              [disabled]="issueSubmitting() || issueForm.invalid || !canProceedToDetail()"
              (click)="onConfirmIssue()"
            >
              {{ issueSubmitting() ? 'กำลังบันทึก...' : 'บันทึก' }}
            </button>
          </div>
        }
      }
    </div>
  </div>
}

<app-confirm-dialog
  #submitConfirmDialog
  modalId="disbursementCoverMemoSubmitDialog"
  icon="success"
  title="ยืนยันการส่งตรวจสอบและรับรอง"
  message="เมื่อยืนยันแล้วจะไม่สามารถแก้ไขข้อมูลได้ ต้องการดำเนินการต่อหรือไม่?"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="actionLoading()"
  (confirmed)="onConfirmSubmit()"
></app-confirm-dialog>

<app-confirm-dialog
  #deleteConfirmDialog
  modalId="disbursementCoverMemoDeleteDialog"
  icon="trash"
  title="ยืนยันการลบใบปะหน้า"
  message="ต้องการลบใบปะหน้านี้หรือไม่ ? รายชื่ออาจารย์ในรอบนี้จะกลับไปอยู่ในรายการรอดำเนินการ"
  cancelText="ยกเลิก"
  confirmText="ลบ"
  [isProcessing]="actionLoading()"
  (confirmed)="onConfirmDelete()"
></app-confirm-dialog>

<app-confirm-dialog
  #actionSuccessDialog
  modalId="disbursementCoverMemoSuccessDialog"
  icon="success"
  [title]="successTitle()"
  [message]="successMessage()"
  confirmText="ปิด"
  [showCancelButton]="false"
  [stackAboveModal]="true"
  (confirmed)="actionSuccessDialog.close()"
></app-confirm-dialog>
